import axios from "@utils/axios"

export default class OnuReport {

    gData = { }

    constructor() {
        this.doInitData();
    }

    getNewReport = () => new Object({ 
        Online: 0,
        Offline: 0,
        LowPower: 0
    })

    doInitData = () => {
        this.gData = this.getNewReport();
        this.gData.Total = 0;
        for(let i=0;i<8;i++){
            this.gData['slot'+(i+1)] = this.getNewReport()
        }
    }

    doLoadData = () => {
        return new Promise(async (resolve,reject) => {
            try {
                let res = await axios('/api/onutable');
                if( res.data.data !== undefined ){
                    this.setReportOnlineOffline(res.data.data)
                }
                res = await axios('/api/moduleonutable');
                if( res.data.data !== undefined ){
                    this.setReportLowPower(res.data.data)
                }
                resolve(this)
            } catch(e) {
                console.log(e)
            }
            reject(null)
        })
    }

    setReportOnlineOffline = (data) => {
        let obj;
        for(let i=0;i<data.length;i++){
            if( data[i].ucCfgONUSlotIndex.length === 0 ){
                this.gData.Offline++;
                continue;
            }
            obj = this.gData['slot'+parseInt(data[i].ucCfgONUSlotIndex)];
            if(data[i].ucCfgONULinkStatus === '1'){ 
                this.gData.Online++;
                obj.Online++
            } else {
                this.gData.Offline++;
                obj.Offline++;
            }
            this.gData['slot'+parseInt(data[i].ucCfgONUSlotIndex)] = obj
        }
        this.gData.Total = data.length
    }

    setReportLowPower = (data) => {
        let obj;
        for(let i=0;i<data.length;i++){
            obj = this.gData['slot'+parseInt(data[i].ucOpticModuleOnuSlotIndex)];
            if( data[i].ucOpticModuleOnuTxPower !== '-' && parseFloat(data[i].ucOpticModuleOnuTxPower) <= -27.00 ){
                this.gData.LowPower++;
                obj.LowPower++;
            }
            this.gData['slot'+parseInt(data[i].ucOpticModuleOnuSlotIndex)] = obj
        }
    }

    getSlotData = (slotNumber) => {
        if( slotNumber > 0 && slotNumber < 9 ){
            return this.gData['slot'+parseInt(slotNumber)]
        }
        throw ("Slot("+slotNumber+") number out of range")
    }

    getTotal = () => this.gData.Total
    getTotalOnline = () => this.gData.Online
    getTotalOffline = () => this.gData.Offline
    getTotalLowPower = () => this.gData.LowPower
}